import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { editDeleteStyles, page as pageIndex } from '../../globals'
import { updateAlertData } from '../../store/reducers/emailAlerts'
import { hideModal } from '../../store/reducers/modal'
import DetailedLoginDates from '../ManagementUserList/components/DetailedLoginDates'
import PermissionsModal from '../ManagementUserList/components/PermissionsModal'
import DeleteModal from '../Modal/components/DeleteModal'
import Modal from '../Modal/Modal'
import STSComponent from "../STSComponent/STSComponent"
import { returnModalData } from './helpers'

class ManagementTools extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      id: '0'
    }
    this.closeModal = this.closeModal.bind(this)
    this.getUserData = this.getUserData.bind(this)
    this.uncheckSubscriptions = this.uncheckSubscriptions.bind(this)
  }

  closeModal = (name) => () => {
    this.props.hideModal(name)
  }

  getUserData = (userId) => {
    this.setState({ id: userId })
  }

  uncheckSubscriptions = () => {
    const { emailManagerTrackData, updateAlertData } = this.props
    const categoryType = emailManagerTrackData.emailCategory.radio.category
    const data = emailManagerTrackData[categoryType].radio
    Object.keys(data).map(function (key) {
      if (data[key]) {
        updateAlertData({ page: pageIndex.dashboard, field: categoryType }, 'switch', key, false)
      }
    })
  }

  returnEmailAlertsBtns = () => {
    const { emailManagerTrackData, listId } = this.props
    if (emailManagerTrackData.emailCategory.radio.category === '') {
      return <div className="track-green-button">
        Update E-mail Address & alert options
      </div>
    } else {
      return <Fragment>
        <button onClick={this.closeModal(`Management-tools-${listId}`)}>Save</button>
        <button
          className="clickable unsubscribe-btn"
          onClick={this.uncheckSubscriptions}
        >
          Unsubscribe all
        </button>
      </Fragment>
    }
  }

  render () {
    const { listId, trackData, modal } = this.props
    const { id } = this.state
    const modalData = returnModalData(listId, trackData, null, hideModal, this.getUserData)
    return <Fragment>
      <Modal
        modalType={`Management-tools-${listId}`}
        contentLabel={`Management-tools-${listId}`}
        customStyles={editDeleteStyles.managementTools}
        modal={modal}
      >
        <div className="get-report-modals-titlearea user-dashboard">
          <div className="info-line-left-tweak user-list">
            <div className="info-line-tweak-middle-block" />
            <div className="info-line-tweak-last-block" />
          </div>
          <div className="get-report-modals-title">{modalData.title}</div>
          {/* <div className="clickable help-alert-btn">Help</div> */}
        </div>
        <div className="background-white dashboard custom-scroll">
          {modalData.node}
        </div>
        <div className="get-report-modals-buttons-area buttonsarea-type2">
          {listId === 'emailAlertManager' ? this.returnEmailAlertsBtns() : null}
          <button onClick={this.closeModal(`Management-tools-${listId}`)}>Close</button>
        </div>
      </Modal>
      <DetailedLoginDates id={id} modal={modal} />
      <DeleteModal
        title={`user-${id}`}
        toCancel={this.closeModal(`Delete-user-${id}`)}
        toDelete={this.closeModal(`Delete-user-${id}`)}
        modal={modal}
      />
      <PermissionsModal
        id={id}
        sendEditedPermissions={this.getEditedData}
        modal={modal}
      />
    </Fragment>
  }

  static propTypes = {
    listId: PropTypes.string,
    hideModal: PropTypes.func,
    trackData: PropTypes.object,
    emailManagerTrackData: PropTypes.object,
    updateAlertData: PropTypes.func,
    modal: PropTypes.object
  }
}

export default connect(state => ({
  trackData: state.clientsFormData.formDataValue.C,
  emailManagerTrackData: state.emailAlerts.formDataValue,
  modal: state.modal
}), {
  hideModal,
  updateAlertData
})(ManagementTools)



// WEBPACK FOOTER //
// ./src/components/ManagementTools/ManagementTools.js